/**
 * Franchise login must not return to guest check-in routes without an active guest session.
 */
const GUEST_KIOSK_PATH =
  /\/naturals\/(?:face-identity|passport|salon)(?:\/guest)?\/(?:welcome|register|pending-registration|mobile)(?:\/|$|\?)/i;

export function isGuestKioskPath(path) {
  const p = String(path || '').trim();
  if (!p) return false;
  return GUEST_KIOSK_PATH.test(p.split('#')[0]);
}

/**
 * @param {string | undefined} from location.state.from after auth redirect
 * @param {string} successPath default hub after login
 * @param {string | undefined} lastPath persisted route from before APK close
 */
export function resolvePostFranchiseLoginPath(from, successPath, lastPath) {
  const fallback = String(successPath || '/').trim() || '/';
  const target = String(from || lastPath || '').trim();
  if (!target) return fallback;
  if (target.includes('/login')) return fallback;
  if (isGuestKioskPath(target)) return fallback;
  return target;
}
